<template lang="pug">
	CertificadoComponent
</template>

<script>
import CertificadoComponent from "@/components/certificados/certificados_top.vue";

export default {
	name: "CertificadoView",
	components: {
		CertificadoComponent
	},
	mounted: function() {
		console.log("Mounted");
		window.scrollTo(0, 0);
	}
}
</script>